export enum EmailAutomationPermissions {
  ALL = "Travel:EmailAutomations:*",
  READ = "Travel:EmailAutomations:Read",
  WRITE = "Travel:EmailAutomations:Write",
}

export function hasEmailAutomationAccess(userPermissions: string[]): boolean {
  const permissions = [
    EmailAutomationPermissions.READ.toString(),
    EmailAutomationPermissions.WRITE.toString(),
    EmailAutomationPermissions.ALL.toString(),
    "*",
  ];
  return userPermissions.some((permission) => permissions.includes(permission));
}
